import React, {useEffect, useState} from 'react'
import PageLayout from '../../components/page-layout'
import {DataGrid} from '@mui/x-data-grid';
import {useGetDevicesOfPage} from '../../services/device';
import RegisterDeviceButton from './register-device-button';
import {makeStyles} from "@material-ui/styles";

export default function InsertedDevices() {

    const getDevicesOfPage = useGetDevicesOfPage()
    const [page, setPage] = useState(0)
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [rowsCount, setRowsCount] = useState(0)
    const [filter, setFilter] = useState([])

    async function fetchPageData() {

        const query = filter && {[filter.columnField]: filter.value}
        setLoading(true)
        const {devices, count} = await getDevicesOfPage(page, query)
        setData(devices)
        setRowsCount(count)
        setLoading(false)

        console.log(devices);

    }

    useEffect(() => {
        fetchPageData()
    }, [page, filter])

    useEffect(() => {
        fetchPageData()

    }, [])

    const classes = useStyles();

    return (
        <PageLayout pageTitle="دستگاه‌های ثبت‌شده">
            <div className={classes.button}>
                <RegisterDeviceButton/>

            </div>
            <div style={{height: 400, width: '100%'}}>

                        <DataGrid
                            columns={columns}
                            rows={data}
                            loading={loading}
                            pagination
                            pageSize={50}
                            rowsPerPageOptions={[]}
                            filterMode="server"
                            paginationMode='server'
                            rowCount={rowsCount}
                            onPageChange={setPage}
                            onFilterModelChange={filters => {
                                setFilter(filters.items[0])
                                setPage(0)
                            }}
                            columnBuffer={3}
                        />
            </div>
        </PageLayout>
    )

}

const useStyles = makeStyles(theme => ({
    button: {
        marginBottom: theme.spacing(4)
    }
}))

const columns = [
    {field: 'imei_1', width: 200, headerName: 'شناسه تجهیز ۱', type: 'string', sortable: false,},
    {field: 'imei_2', width: 200, headerName: 'شناسه تجهیز ۲', type: 'string', sortable: false},
    {field: 'model', width: 150, headerName: 'مدل', type: 'string'},
    {field: 'activationCode', width: 150, headerName: 'کد فعالسازی', type: 'string', sortable: false},
    {field: 'boxCode', width: 150, headerName: 'رمز موقت', type: 'string', sortable: false},
    {field: 'nationalId', width: 130, headerName: 'کد ملی', sortable: false,},
    {field: 'customer', width: 150, headerName: 'مالک', sortable: false,},
    {field: 'phoneNumber', width: 130, headerName: 'شماره‌تلفن', sortable: false, }
]
